import React, { useState } from 'react';

const IPCheck = (props) => {

    
    return (
        <div className="form-group col-md-12">
            <div className="form-check">
                <input type="checkbox" checked={props.obj.value} onChange={(e) => props.setValue(props.obj.id, e.target.checked)} className="form-check-input" disabled={props.readonly} />
                <label>{props.obj.label}</label>
            </div>
            
            
        </div>

    );
}


export default IPCheck;